import React from "react";

export function useLightbox() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [src, setSrc] = React.useState<string | null>(null);
  const [alt, setAlt] = React.useState<string>("");

  const openLightbox = (imageSrc: string, imageAlt: string = "") => {
    setSrc(imageSrc);
    setAlt(imageAlt);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
    setSrc(null);
  };

  return { isOpen, src, alt, openLightbox, closeLightbox };
}
